import { useCallback,useState } from "react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import { createAxiosInstance } from "api/axiosConfig";
import { PATIENT_DOCUMENTS_CONTROLER_URL_ID } from "api/Service";
import { fetchDocumentForPreview as fetchDocumentPreviewHelper } from "utils/documentDownload";

export const useDocumentPreview = () => {
  const [previewData, setPreviewData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [document, setDocument] = useState(null);

  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const fetchDocument = useCallback(async (documentId) => {
    if (!documentId) return;

    setIsLoading(true);
    try {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenant}${PATIENT_DOCUMENTS_CONTROLER_URL_ID}${documentId}`
      );
      setDocument(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching document:", error);
      toast.error("Failed to load document");
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [tenant]);

  const downloadDocumentForPreview = useCallback(async (documentId, patientId) => {
    if (!documentId || !patientId) return null;

    try {
      return await fetchDocumentPreviewHelper(documentId, patientId, tenant);
    } catch (error) {
      console.error("Error downloading document:", error);
      toast.error("Failed to load document preview");
      throw error;
    }
  }, [tenant]);

  const openPreview = useCallback(async (documentId, patientId) => {
    try {
      setIsLoading(true);
      const imageData = await downloadDocumentForPreview(documentId, patientId);
      if (imageData) {
        setPreviewData(imageData);
        await fetchDocument(documentId);
      }
    } catch (error) {
      console.error("Error opening preview:", error);
    } finally {
      setIsLoading(false);
    }
  }, [downloadDocumentForPreview, fetchDocument]);

  const closePreview = useCallback(() => {
    setPreviewData(null);
    setDocument(null);
  }, []);

  const isImage = document?.imageType ?? false;

  return {
    previewData,
    document,
    isLoading,
    isImage,
    openPreview,
    closePreview,
    fetchDocument,
  };
};
